export default {
      id: "ic_nav_score-usage",
      viewBox: "0 0 31 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_score-usage",
      toString: function () {
        return this.url;
      }
    }